import { render, staticRenderFns } from "./ImageResource.vue?vue&type=template&id=4f1d0427&scoped=true"
import script from "./ImageResource.vue?vue&type=script&lang=js"
export * from "./ImageResource.vue?vue&type=script&lang=js"
import style0 from "./ImageResource.vue?vue&type=style&index=0&id=4f1d0427&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1d0427",
  null
  
)

export default component.exports